<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center px-3>
      <v-flex xs12 sm6>
        <v-layout wrap justify-center py-5>
          <!-- <v-flex xs12 py-4>
            <span class="head2">Bank Details</span>
              </v-flex> -->
          <v-flex xs12>
            <v-text-field
              prepend-icon="mdi-account-outline"
              label="Account Holder"
              v-model="bankdata.accountHolder"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="bankdata.accountNo"
              prepend-icon="mdi-pen"
              label="Account Number"
            >
            </v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              prepend-icon="mdi-bank-outline"
              v-model="bankdata.bank"
              label="Bank"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              prepend-icon="mdi-source-branch"
              v-model="bankdata.branch"
              label="Branch"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              prepend-icon="mdi-fountain-pen-tip"
              v-model="bankdata.ifsc"
              label="IFSC"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 md6 py-4>
            <v-btn dark block color="#FEBD08" @click="profileUpdate">
              SAVE
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["bank"],

  data() {
    return {
      showSnackBar: false,
      msg: "",
      timeout: 3000,
    };
  },
  computed: {
    bankdata() {
      if (this.bank) {
        return this.bank;
      } else return {};
    },
  },
  methods: {
    profileUpdate() {
     
     let getURL;
      if (this.$route.query.Type == "foodSeller") {
        getURL = "/admin/seller/edit";
      }
      if (this.$route.query.Type == "grocerySeller") {
        getURL = "/grocery/admin/seller/edit";
      }

      axios({
        method: "post",
        // url: "/admin/seller/edit",
        url: getURL,

        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.bankdata,
      }).then((response) => {
        if (response.data.status) {
          this.$emit("stepper", {
            getData: true,
          });
          this.msg = "Bank details updated successfully";
          this.showSnackBar = true;
        } else {
          this.showSnackBar = true;
          this.msg = response.data.msg;
        }
        this.appLoading = false;
      });
    },
  },
};
</script>
